var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.53518 1.53538C1.75787 1.31276 2.05986 1.1877 2.37475 1.1877C2.68963 1.1877 2.99162 1.31276 3.21431 1.53538L9.49975 7.82082L15.7852 1.53538C15.8947 1.42196 16.0258 1.3315 16.1706 1.26926C16.3155 1.20703 16.4713 1.17427 16.629 1.1729C16.7867 1.17153 16.9431 1.20157 17.089 1.26128C17.2349 1.32099 17.3675 1.40916 17.479 1.52066C17.5905 1.63216 17.6787 1.76475 17.7384 1.91069C17.7981 2.05663 17.8282 2.21299 17.8268 2.37067C17.8254 2.52835 17.7927 2.68417 17.7304 2.82905C17.6682 2.97393 17.5777 3.10496 17.4643 3.21451L11.1789 9.49994L17.4643 15.7854C17.6806 16.0093 17.8003 16.3093 17.7976 16.6207C17.7949 16.932 17.67 17.2299 17.4498 17.45C17.2297 17.6702 16.9318 17.7951 16.6205 17.7978C16.3091 17.8005 16.0091 17.6808 15.7852 17.4645L9.49975 11.1791L3.21431 17.4645C2.99034 17.6808 2.69038 17.8005 2.37902 17.7978C2.06766 17.7951 1.76982 17.6702 1.54965 17.45C1.32948 17.2299 1.20459 16.932 1.20188 16.6207C1.19918 16.3093 1.31887 16.0093 1.53518 15.7854L7.82062 9.49994L1.53518 3.21451C1.31256 2.99182 1.1875 2.68983 1.1875 2.37494C1.1875 2.06006 1.31256 1.75807 1.53518 1.53538V1.53538Z",
    fill: "#11B7B5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseMobile);
export default __webpack_public_path__ + "static/media/close-mobile.e18357f4.svg";
export { ForwardRef as ReactComponent };